import script from "./right-content.vue?vue&type=script&setup=true&lang=js"
export * from "./right-content.vue?vue&type=script&setup=true&lang=js"

import "./right-content.vue?vue&type=style&index=0&id=18461bac&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18461bac"]])

export default __exports__